import React, { useEffect, useState } from "react"; import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row
} from "reactstrap";
import { getAllReadNotifications, getAllUnReadNotifications, updateMarkAllAsRead, updateMarkAsRead } from "../../helpers/UAM/notificaiton.helper";

const Notifications = () => {

  document.title = "Notification";


  const [isSelectAll, setIsSelectAll] = useState(false)
  const [isShowRead, setIsShowRead] = useState(true)
  const [isShowUnRead, setIsShowUnRead] = useState(false)
  const [isOneSelected, setIsOneSelected] = useState(false)
  const [notifications, setNotifications] = useState([]);
  const [selectedList, setSelectedList] = useState([]);
  const [limit, setLimit] = useState(10);
  const [limit2, setLimit2] = useState(10);
  let user = JSON.parse(localStorage.getItem("user"))


  useEffect(() => {
    getAllUnReadNotifications({ userId: user.id, limit })
      .then((response) => {
        setNotifications(response.data.data)
      })
      .catch((error) => {

      });
  }, []);

  const handleSelectChange = () => {
    setIsSelectAll(!isSelectAll)
    setIsOneSelected(false)
  }

  const handleCheckBox = (e) => {
    if (e.target.checked) {
      selectedList.push(e.target.value)
      setIsOneSelected(true)
    } else {
      let newData = selectedList.filter((ele) => {
        return e.target.value != ele
      })
      if (newData.length == 0) {
        setIsOneSelected(false)
      }
      setSelectedList(newData)
    }
  }

  const getAllUnReadNotification = () => {
    getAllUnReadNotifications({ userId: user.id, limit })
      .then((response) => {
        if (!response.status) {
          setNotifications([])
        } else {
          setNotifications(response.data.data)
        }
      })
      .catch((error) => {

      });
    setIsShowRead(true)
    setIsShowUnRead(false)
  }

  const getAllReadNotification = () => {
    getAllReadNotifications({ userId: user.id, limit: limit2 })
      .then((response) => {
        if (!response.status) {
          setNotifications([])
        } else {
          setNotifications(response.data.data)
        }
      })
      .catch((error) => {

      });
    setIsShowRead(false)
    setIsShowUnRead(true)
  }

  const formatDateTime = (dateTimeString) => {
    const dateTime = new Date(dateTimeString);

    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    };

    return dateTime.toLocaleString('en-US', options);
  };

  const parsedData = (data) => {
    return <div dangerouslySetInnerHTML={{ __html: data }}></div>
  }

  const loadMore = () => {
    if (isShowRead) {
      let pageLimit = limit + 10
      setLimit(pageLimit)
      getAllUnReadNotifications({ userId: user.id, limit: pageLimit })
        .then((response) => {
          setNotifications(response.data.data)
        })
        .catch((error) => {

        });
    } else {
      let pageLimit = limit2 + 10
      setLimit2(pageLimit)
      getAllReadNotifications({ userId: user.id, limit: pageLimit })
        .then((response) => {
          setNotifications(response.data.data)
        })
        .catch((error) => {

        });
    }
  }

  const markSelected = () => {
    updateMarkAsRead({ id: selectedList })

      .then((response) => {
        if (response.code == "201") {
          setSelectedList([])
          setIsShowUnRead(true)
          setIsShowRead(false)
          setIsOneSelected(false)
          setIsSelectAll(false)
          getAllUnReadNotification()
        }
      })
      .catch((error) => {

      });
  }

  const markAllSelected = () => {
    updateMarkAllAsRead({ userId: user.id })
      .then((response) => {
        if (response.code == "201") {
          getAllUnReadNotification()
          setIsSelectAll(false)
        }
      })
      .catch((error) => {

      });
  }


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* <Breadcrumbs title="NOTIFICATIONS" /> */}
          <Row className="vertical-scroll">
            <Col xs="12">
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between">
                    {notifications.length !== 0 && isShowRead && (
                      <div>
                        <Input
                          type="checkbox"
                          name="isSecured"
                          onClick={handleSelectChange}
                          checked={isSelectAll}
                          style={{ width: "20px", height: "20px", border: "1px solid black" }}
                        />
                        <Label className="ms-2 font-size-14" style={{ marginTop: "4px" }}>Select all notification</Label>
                      </div>
                    )}

                    {isSelectAll && isShowRead && (
                      <div>
                        <button type="button" className="btn btn-outline-success" onClick={markAllSelected}>Mark as read</button>
                      </div>
                    )}

                    {isOneSelected && isShowRead && (
                      <div>
                        <button type="button" className="btn btn-outline-success" onClick={markSelected}>Mark as read</button>
                      </div>
                    )}

                    {isShowUnRead && (
                      <div style={{ marginLeft: "auto" }}>
                        <button type="button" className="btn btn-outline-success" onClick={getAllUnReadNotification} >Show unread notification</button>
                      </div>
                    )}

                    {isShowRead && !isSelectAll && !isOneSelected && (
                      <div style={{ marginLeft: "auto" }}>
                        <button type="button" className="btn btn-outline-success" onClick={getAllReadNotification}>Show read notification</button>
                      </div>
                    )}
                  </div>
                  <div>
                    <div>
                      {notifications.map((item, index) => (
                        <div className="d-flex justify-content-between mt-3" key={item.id} style={{ borderTop: "1px solid rgb(234,237,239)" }}>
                          <div className="d-flex align-items-center">
                            {isShowRead && isSelectAll && (
                              <Input
                                type="checkbox"
                                value={item.id}
                                className="mt-0"
                                style={{ border: "1px solid black", width: "20px", height: "20px"}}
                                checked={isSelectAll}
                              // onClick={handleSelectChange}
                              />)}


                            {isShowRead && !isSelectAll && (
                              <Input
                                type="checkbox"
                                value={item.id}
                                className="mt-0"
                                onClick={handleCheckBox}
                                style={{ border: "1px solid black", width: "20px", height: "20px"}}
                                defaultChecked={false}
                              />)}
                            <div className="mt-3 ms-3">
                              <p style={{ fontSize: "16px" }}>{item.notificationHeader}</p>
                            </div>
                          </div>


                          <div className="mt-3" style={{ width: "148px" }}>{formatDateTime(item.createdAt)}</div>
                        </div>
                      ))}

                      {notifications.length == 0 && (
                        <div className="mt-3" style={{ borderTop: "1px solid rgb(234,237,239)" }}>
                          <h4 className="mt-3" style={{ textAlign: "center" }}>No new notification</h4>
                        </div>
                      )}
                    </div>

                    {notifications.length !== 0 && (
                      <div style={{ borderTop: "1px solid rgb(234,237,239)" }} className="mt-3">
                        <button type="button" className="btn btn-outline-success mt-3" onClick={loadMore}>Load more</button>
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Notifications